module.exports = __webpack_public_path__ + "img/input_7.7dabc07f.png";